import React from "react";

import { INTRO } from "../../data/content";
import Picture from "../general/Picture";
import PlatformLinks from "../general/PlatformLinks";
import IntroVideo from "./IntroVideo";
import { useRevealOnScroll } from "../hooks/motion";

//Half width photo that fades in as it scrolls into view
const RevealPicture = ({ name, alt, position }) => {
  const [ref, isRevealed] = useRevealOnScroll();

  return (
    <div
      ref={ref}
      className={`split-media reveal ${isRevealed ? "is-revealed" : ""}`}
      style={{ "--object-position": position }}
    >
      <Picture
        name={name}
        widths={[800, 1400]}
        fallbackWidth={1000}
        sizes={"(max-width: 767px) 100vw, 50vw"}
        alt={alt}
        width={"1000"}
        height={"558"}
        className={"split-img"}
      />
    </div>
  );
};

//The three text + photo/video blocks below the hero
const Intro = () => {
  return (
    <React.Fragment>
      <section className={"split"}>
        <div className={"split-text split-text-first"}>
          <p>{INTRO.INVITATION}</p>
          <p className={"available-on"}>Available On:</p>
          <PlatformLinks className={"intro-platforms"} />
        </div>
        <IntroVideo />
      </section>

      <section className={"split"}>
        <RevealPicture
          name={"why"}
          alt={"A visitor in a patterned coat studying a large black and white drawing in a gallery"}
          position={"50% 50%"}
        />
        <div className={"split-text split-text-right"}>
          <p>{INTRO.WHY}</p>
        </div>
      </section>

      <section className={"split split-media-first-mobile"}>
        <div className={"split-text split-text-left"}>
          <p>{INTRO.CORE}</p>
        </div>
        <RevealPicture
          name={"core"}
          alt={"Jo-Ann Strauss reading an art book at a desk with a podcast microphone"}
          position={"44% 48%"}
        />
      </section>
    </React.Fragment>
  );
};

export default Intro;
